import {
  ModuleRegistry,
  provideGlobalGridOptions,
  themeQuartz,
} from "ag-grid-community";
import { AgChartsEnterpriseModule } from "ag-charts-enterprise";
import { AllEnterpriseModule } from "ag-grid-enterprise";

ModuleRegistry.registerModules([
  AllEnterpriseModule.with(AgChartsEnterpriseModule),
]);

const legacyGridTheme = themeQuartz.withParams({
  accentColor: "#0078d4",
  backgroundColor: "#ffffff",
  borderColor: "#bdc3c7",
  cellTextColor: "#000000",
  fontFamily: "Roboto, sans-serif",
  fontSize: 12,
  headerBackgroundColor: "#f5f5f5",
  headerFontSize: 12,
  headerTextColor: "#000000",
  rowBorder: { color: "#d9d9d9", style: "solid", width: 1 },
  spacing: 4,
});

provideGlobalGridOptions({
  autoSizeStrategy: {
    type: "fitCellContents",
    scaleUpToFitGridWidth: true,
    applyToUiActions: true,
  },
  calculatedColumns: {
    applyMode: "deferred",
    dataTypes: ["number", "text", "boolean", "date", "dateString"],
    expressionPickers: ["columns", "functions", "operators"],
  },
  cellSelection: {
    enableHeaderHighlight: true,
    handle: {
      mode: "fill",
    },
  },
  enableCharts: true,
  headerHeight: 32,
  loadingOverlayComponentParams: {
    loadingMessage: "Loading data...",
  },
  noRowsOverlayComponentParams: {
    noRowsMessage: "No data available",
  },
  rowSelection: {
    mode: "singleRow",
    checkboxes: true,
    enableClickSelection: true,
  },
  selectionColumnDef: {
    width: 30,
    resizable: false,
    sortable: false,
    suppressHeaderMenuButton: true,
  },
  rowHeight: 25,
  theme: legacyGridTheme,
});